import { property, State } from '@mfec/lit/store';
import type { Purpose } from '@mfec/types/model';

export class ConsentStore extends State {
  [key: string | symbol]: unknown;

  // the initial consents
  @property({ value: [] }) initialConsents!: Purpose[];

  // the consent state
  @property({ value: [] }) actualConsents!: Purpose[];

  findPurposeById(purposeId : string) {
    return this.actualConsents.find((purpose) => purpose.purposeId === purposeId);
  }
}

export const store = new ConsentStore();
